<template>
  <div class="layout">
    <NavbarHero
      @open-login="openLogin"
      @open-signup="openSignup"
      @close-login="closeLogin"
      @close-signup="closeSignup"
      @change-signup="changeSignup"
      @change-login="changeLogin"
    />
    <main>
      <slot />
    </main>
    <FooterPage />
  </div>
</template>

<script setup>
import FooterPage from "~/components/FooterPage.vue";
import NavbarHero from "~/components/NavbarHero.vue";
import { useAuthModal } from "~/composables/useAuthModal";

const {
  openLogin,
  openSignup,
  closeLogin,
  closeSignup,
  changeLogin,
  changeSignup,
} = useAuthModal();
</script>
